import { render, staticRenderFns } from "./PackagingRow.vue?vue&type=template&id=7ba4259e&scoped=true&"
import script from "./PackagingRow.vue?vue&type=script&lang=js&"
export * from "./PackagingRow.vue?vue&type=script&lang=js&"
import style0 from "./PackagingRow.vue?vue&type=style&index=0&id=7ba4259e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba4259e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
